<template>
  <section class="home_news_area">
    <news-header title-divider />
    <div class="page_content_area">
      <div class="container">
        <div class="index_news_area row">
          <template v-if="getNews.length > 0">
            <div
              v-for="news in getNews"
              :key="news.news_id"
              class="col-12"
            >
              <div class="index_news_block clearfix">
                <router-link :to="`/news/${news.news_id}`">
                  <div class="left_block">
                    <div
                      class="news_images_block"
                      :class="news.news_type_bg"
                    >
                      <div class="triangle" />
                    </div>
                    <div class="news_date_area clearfix">
                      <div class="year">
                        {{ news.news_published_at || new Date() | moment("YYYY") }}
                      </div>
                      <div
                        class="date"
                        :class="news.news_type_color"
                      >
                        {{ news.news_published_at || new Date() | moment("MM/DD") }}
                      </div>
                    </div>
                  </div>
                  <div class="right_block">
                    <div class="decorative_block">
                      <div class="decorative_line" />
                    </div>
                    <div class="news_content_block">
                      <div class="mb-2">
                        <tag
                          :color="news.news_type_color"
                        >
                          {{ news.news_type_text }}
                        </tag>
                      </div>
                      <div class="title">
                        {{ news.news_topic }}
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </template>
        </div>
        <div class="more_btn_block row">
          <div class="col-12">
            <router-link
              to="/news"
              class="more_btn"
            >
              更多新聞訊息
              <font-awesome-icon icon="sign-out-alt" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import NewsHeader from '~components/pages/news/NewsHeader'
import Tag from '~components/common/Tag'
export default {
  name: 'News',
  components: {
    NewsHeader,
    Tag
  },
  props: {
    piecesNews: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('pages/home', [
      'getNews'
    ])
  },
  async created () {
    await this.getHomeNewsData()
  },
  methods: {
    ...mapActions('pages/home', [
      'getHomeNewsData'
    ])
  }
}
</script>
